/* eslint-disable */
export default {
  unknown: '不明',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
